module.exports = __webpack_public_path__ + "static/media/presse03.4bcd171b.png";